import type { GameLevel } from '../../types/game';

// Solution: Black = 4, 7, 10 | Sheriff = 3 | Red = 1, 2, 5, 6, 8, 9
//
// Deduction path:
// 1. Two sheriff claims: seat 3 says seat 7=black; seat 7 (evicted day 1) says seat 3=black
// 2. Hint 1 (3 blacks voted same target day 1) → day 1: seats 4,7,10 all voted for seat 3 → blacks = 4,7,10
// 3. Seat 7 is black → fake sheriff; seat 3 is real sheriff ✓
// 4. Seat 3's checks: 7=black ✓, 4=black ✓ — consistent with solution
// 5. Hints 2 and 3 confirm remaining reds

export const LEVEL_002: GameLevel = {
  id: 'level-002',
  title: 'Двойной блеф',
  difficulty: 'intermediate',
  brief: `Детектив, это дело сложнее.

Первой ночью погиб Игрок 6. На первом заседании сразу двое объявили себя Шерифом: Игрок 3 и Игрок 7. Каждый обвинил другого. В итоге стол выгнал Игрока 7.

Второй ночью был убит Игрок 1. На втором заседании Шериф раскрыл вторую проверку, и стол выгнал Игрока 4.

Кто лгал — Игрок 3 или Игрок 7? Ответ на этот вопрос раскроет всё дело.`,

  nights: [
    { night: 1, killedPlayer: 6 },
    { night: 2, killedPlayer: 1 },
  ],

  days: [
    {
      day: 1,
      votes: [
        { voter: 1, target: 7 },
        { voter: 2, target: 7 },
        { voter: 3, target: 7 },
        { voter: 4, target: 3 },
        { voter: 5, target: 7 },
        { voter: 7, target: 3 },
        { voter: 8, target: 7 },
        { voter: 9, target: 7 },
        { voter: 10, target: 3 },
      ],
      evictedPlayer: 7,
    },
    {
      day: 2,
      votes: [
        { voter: 2, target: 4 },
        { voter: 3, target: 4 },
        { voter: 4, target: 9 },
        { voter: 5, target: 4 },
        { voter: 8, target: 4 },
        { voter: 9, target: 10 },
        { voter: 10, target: 3 },
      ],
      evictedPlayer: 4,
    },
  ],

  sheriffClaims: [
    {
      claimant: 3,
      day: 1,
      checks: [
        { night: 1, checkedPlayer: 7, result: 'black' },
        { night: 2, checkedPlayer: 4, result: 'black' },
      ],
    },
    {
      claimant: 7,
      day: 1,
      checks: [{ night: 1, checkedPlayer: 3, result: 'black' }],
    },
  ],

  hints: [
    {
      id: 'h1',
      type: 'behavior',
      text: 'В первый день трое чёрных голосовали согласованно — все трое против одного красного игрока.',
    },
    {
      id: 'h2',
      type: 'arithmetic',
      text: 'Среди игроков 2, 5, 8 и 9 нет ни одного чёрного.',
    },
    {
      id: 'h3',
      type: 'behavior',
      text: 'Выгнанный в первый день лже-шериф был членом мафии.',
    },
  ],

  solution: {
    1: 'red',
    2: 'red',
    3: 'sheriff',
    4: 'black',
    5: 'red',
    6: 'red',
    7: 'black',
    8: 'red',
    9: 'red',
    10: 'black',
  },
};
